<div class="mp-page">
  <header class="mp-header">
    <button type="button" class="mp-back" (click)="cancel()" aria-label="Back">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>
    </button>
    <div class="mp-heading">
      <h1 class="mp-title">Flying from</h1>
      <p class="mp-sub">Where does your trip start?</p>
    </div>
  </header>

  <div class="mp-body">
    <div class="mp-search">
      <i class="fas fa-search mp-search__icon" aria-hidden="true"></i>
      <input
        #searchInput
        class="mp-search__input"
        type="text"
        inputmode="search"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        placeholder="City or airport"
        aria-label="Search for a city or airport"
        [formControl]="searchControl">
      @if (searchControl.value) {
        <button type="button" class="mp-search__clear" (click)="clearSearch(searchInput)" aria-label="Clear search">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      }
    </div>
    @if (isLoadingKiwi) {
      <div class="mp-loading" role="progressbar" aria-label="Searching"></div>
    }

    @if (filteredCities?.length > 0) {
      <h2 class="mp-label">Suggestions</h2>
      <ul class="mp-list mp-card">
        @for (group of filteredCities; track group.label) {
          <li>
            <button type="button" class="mp-row" (click)="onSelect(group.primary)">
              <span class="mp-row__code">{{ group.primary.iata }}</span>
              <span class="mp-row__text">
                <span class="mp-row__name">{{ group.label }}</span>
                <span class="mp-row__meta">{{ group.primary.name }}</span>
              </span>
              <i class="fas fa-chevron-right mp-row__chevron" aria-hidden="true"></i>
            </button>
          </li>
          @if (group.others.length > 0) {
            <li class="mp-nearby">
              {{ group.others.length }} more airport{{ group.others.length > 1 ? 's' : '' }} in {{ group.city }}
            </li>
            @for (airport of group.others; track airport.iata) {
              <li>
                <button type="button" class="mp-row mp-row--nested" (click)="onSelect(airport)">
                  <span class="mp-row__code">{{ airport.iata }}</span>
                  <span class="mp-row__text">
                    <span class="mp-row__name">{{ airport.name }}</span>
                    <span class="mp-row__meta">{{ airport.city }}, {{ airport.country }}</span>
                  </span>
                  <i class="fas fa-chevron-right mp-row__chevron" aria-hidden="true"></i>
                </button>
              </li>
            }
          }
        }
      </ul>
    } @else if (hasSearched && !isLoadingKiwi) {
      <div class="mp-empty">
        <span class="mp-empty__icon" aria-hidden="true"><i class="fas fa-search"></i></span>
        <b>No airports found</b>
        <span>Check the spelling, or try the city name or airport code.</span>
      </div>
    }

    @if (!isLoadingKiwi && !(filteredCities?.length > 0) && !hasSearched) {
      @if ((recentSearches$ | async)?.length > 0) {
        <h2 class="mp-label">Recent searches</h2>
        <ul class="mp-list mp-card">
          @for (search of recentSearches$ | async; track search.iata) {
            <li>
              <button type="button" class="mp-row" (click)="onSelect(search)">
                <span class="mp-row__code">{{ search.iata }}</span>
                <span class="mp-row__text">
                  <span class="mp-row__name">{{ search.name }}</span>
                  <span class="mp-row__meta">{{ search.city }}, {{ search.country }}</span>
                </span>
                <i class="fas fa-chevron-right mp-row__chevron" aria-hidden="true"></i>
              </button>
            </li>
          }
        </ul>
      }

      <h2 class="mp-label">Popular airports</h2>
      <ul class="mp-list mp-card">
        @for (airport of popularAirports; track airport.iata) {
          <li>
            <button type="button" class="mp-row" (click)="onSelect(airport)">
              <span class="mp-row__code">{{ airport.iata }}</span>
              <span class="mp-row__text">
                <span class="mp-row__name">{{ airport.city }}, {{ airport.country }}</span>
                <span class="mp-row__meta">{{ airport.name }}</span>
              </span>
              <i class="fas fa-chevron-right mp-row__chevron" aria-hidden="true"></i>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</div>
